import { withChartLayout } from 'components/common';
import AdmissionData from 'components/features/chart/admission-history/admission-data/AdmissionData';

const AdmissionDataPage = withChartLayout('Admission Data')(AdmissionData);
export default AdmissionDataPage;
